/**
 * 4.0商详页-内容组件-左文右图（视频）
 * @constructor
 */
export function PdpLeftTextRightImg() {
  (function () {
    $(function () {

      let scrollPosition = 0

      // 监听全屏变化
      document.addEventListener('fullscreenchange', handleFullScreenChange);
      document.addEventListener('webkitfullscreenchange', handleFullScreenChange);

      // 监听全屏事件
      function handleFullScreenChange() {
        if (document.fullscreenElement) {
          // 记录当前滚动位置
          scrollPosition = window.scrollY || document.documentElement.scrollTop;
        } else {
          setTimeout(() => {
            // document.body.style.display = 'none'; // 强制重绘
            // document.body.offsetHeight; // 触发重绘
            // document.body.style.display = '';
            window.scrollTo({ top: scrollPosition, }); // 恢复滚动位置
          }, 50); // 确保 DOM 状态稳定
        }
      }

      function observeVideo(target, jkyVideo) {
        // 视频进入视口监听播放
        const Observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // 取消任何焦点
              if (document.activeElement) {
                document.activeElement.blur();
              }

              jkyVideo.videoInfo.autoplay = true
              jkyVideo.loadContent(false)
            } else {
              jkyVideo.videoInfo.autoplay = false
              jkyVideo.pause()
            }
          })
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0.25, // 设置阈值为80%，即视频可见面积超过50%触发播放
        })

        Observer.observe(target)
      }

      document.querySelectorAll('.pdp-left-text-right-img').forEach(item => {
        item.querySelectorAll('jky-video').forEach(jkyVideo => {
          const clientWidth = document.documentElement.clientWidth || document.body.clientWidth

          // PC 端
          if (clientWidth >= 1024) {
            if (jkyVideo.classList.contains('pc-video')) {
              observeVideo(item, jkyVideo)
            }
          } 
          // Mobile 端
          else {
            if (jkyVideo.classList.contains('mb-video')) {
              observeVideo(item, jkyVideo)
            }
          }
          
        })
      })
    })
  })();
}
